import useSystemTrackerHook from "@/shared/hooks/useSystemTrackerHook";
import Formules from "./Formules";

const LiveFormules = () => {
  const { systemTrackerQuery: options } = useSystemTrackerHook();
  return options?.data?.use_formulas ? <Formules /> : null;
};

export default LiveFormules;
